/**
 * Shared theme tokens for the OCPP module.
 *
 * The colour palette aligns with the existing design system used by
 * MyChargers / MyChargerInfoCard so the new page feels native rather than
 * grafted on. Define new tokens here rather than sprinkling literals.
 */

export const OcppTheme = {
  bg: '#1A1D21',
  surface: '#242830',
  surfaceAlt: '#1F2227',
  surfaceMuted: '#22262B',
  border: '#374151',
  divider: '#292D33',
  textPrimary: '#F9FAFB',
  textSecondary: '#D1D5DB',
  textMuted: '#9CA3AF',
  textDim: '#8D8E90',
  accent: '#39BEB7',
  accentDim: 'rgba(57, 190, 183, 0.15)',
  accentDark: '#2A8D88',
  warning: '#F59E0B',
  danger: '#EF4444',
  dangerDark: '#DC2626',
  success: '#51B868',
  info: '#3B82F6',
  black: '#0B1E1D',
} as const;

export type OcppThemeKey = keyof typeof OcppTheme;
